module.exports = __webpack_public_path__ + "img/arrow-left-right.fa1e111d.svg";